import { BaseLayout } from "@appbase/templates";
import Vue from "vue";
import VueRouter, { NavigationGuard, RouteConfig } from "vue-router";
// modules
import { routes as moduleBoard } from "@board/module";
import moduleAccount from "../modules/@account/router";
import authGuard from "@account/router/auth-guard-entraid";
import moduleAppbase from "@appbase/router";
import { PortalCacheGuard, SkinGuard, multiguard, I18nGuard, CssSwitchingGuard } from "../modules/@appbase/router";
import moduleOrgmap from "../modules/@orgmap/router";
import moduleHome from "../modules/home/router";
import moduleReserve from "../modules/reserve/router";
import moduleSurvey from "../modules/survey/router";
import moduleGnb from "../modules/@gnb/router";
// import moduleWebparts from '../modules/@webparts/router'
import { routes as moduleWebparts } from "@webparts/module";
import menuHelper from "@appbase/util/menu-helper";
import appbaseStore from "@appbase/store";

const RedirectView = () => import("@home/views/RedirectView.vue");

Vue.use(VueRouter);

const boradReadPath = ["/BoardPopup/readPopup", "/Board/modal/read", "/Board/total/modal/read"];
/**
 * Teams 내부에서 동작 중인지 여부
 * @returns true: teams에서 동작 중임, false: 일반 브라우저
 */
const isTeams = () => appbaseStore.state.teams;

// 브라우저 감지
// 현재 MS Teams 지원 웹/모바일 클라이언트
// https://docs.microsoft.com/en-us/microsoftteams/get-clients
const BrowserGuard: NavigationGuard = (to, from, next) => {
    var ua = window.navigator.userAgent;
    var iOS = ua.indexOf("iPhone");
    var Android = ua.indexOf("Android");

    console.debug('BrowserGuard', iOS, Android, isTeams());
    // yaskawa 팀즈 모바일 앱에서만 mobile 로 이동
    //mobile
    if ((iOS > 0 || Android > 0) && isTeams()) {
        var isReadPopup = boradReadPath.indexOf(to.path) != -1;
        var sysid = to.query.SYSID;
        var articleid = to.query.ARTICLEID;
        if (isReadPopup && sysid && articleid) {
            window.location.href = `/mobile/board/read?boardId=${sysid}&articleId=${articleid}`;
        } else {
            window.location.href = "/mobile";
        }
    } else {
        next();
    }
};

const HomePageGuard: NavigationGuard = (to, from, next) => {
    if (to.path === "/") {
        return menuHelper.goHome(next);
    }
    next();
};

const routes: RouteConfig[] = [
    {
        path: "/",
        component: BaseLayout,
        beforeEnter: multiguard(
            [BrowserGuard, SkinGuard, PortalCacheGuard, I18nGuard, HomePageGuard, CssSwitchingGuard],
            // [BrowserGuard, SkinGuard, PortalCacheGuard, I18nGuard, HomePageGuard,CssSwitchingGuard],
            ["/account/login", "/error"]
        ),
        children: [
            ...moduleAppbase,
            ...moduleOrgmap,
            ...moduleBoard.routes,
            ...moduleHome,
            ...moduleReserve,
            ...moduleSurvey,
            ...moduleGnb,
            ...moduleWebparts,
        ],
    },
    {
        path: "/",
        component: BaseLayout,
        beforeEnter: CssSwitchingGuard,
        children: [
            ...moduleAccount,
            {
                path: "redirect",
                name: "redirect-page",
                component: RedirectView,
            },
        ],
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

// router.beforeEach(async (to, from, next) => {
//   const result = await authGuard(to, from, next)
//   console.log('result', result)
// })

router.beforeEach(authGuard);
// 전후 나눠서 추가해야 될듯?

// router.beforeEach(CssSwitchingGuard)

export default router;
